import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kiacarenceonrentinpune() {



const cardData = {
  keyword: " Kia Carens On Rent in Pune",

headingDescription: "Velocity Cab provides easy and affordable Kia Carens on rent in Pune, offering a spacious, comfortable, and practical travel option for families, group outings, corporate travel, and leisure trips. Our well‑maintained Kia Carens vehicles feature premium seating for up to 6–7 passengers, generous luggage space, and smooth performance on city roads and highways alike. Whether you need an hourly rental, full‑day service, airport transfer, or outstation travel, Velocity Cab offers flexible booking options with transparent pricing and no hidden charges. With professional drivers, prompt service, easy online booking, and 24/7 customer support, Velocity Cab is the trusted choice for Kia Carens rental in Pune.",

topPlaces: [

  {
    title: "Panchgani",
    description: "Panchgani is a charming hill station known for its rolling hills, Table Land, and colonial-era charm. Sedan cab travelers can explore scenic viewpoints, strawberry farms, and lush valleys while enjoying a comfortable outstation journey. The peaceful atmosphere makes it ideal for relaxation, sightseeing, and photography."
  },
  {
    title: "Lavasa",
    description: "Lavasa is a beautifully planned hill city near Pune offering colorful architecture, lakeside views, and adventure activities. Travelers using a sedan cab can enjoy a scenic drive through the Western Ghats, stroll along the waterfront promenade, and indulge in boating, cycling, and nature walks. It is a perfect destination for a refreshing day trip."
  },
  {
    title: "Matheran",
    description: "Matheran is India's smallest hill station and is famous for its vehicle-free environment, dense forests, and stunning viewpoints. Sedan cab travelers can drive to Dasturi Point before exploring the hill station on foot or horseback. Popular attractions include Panorama Point, Echo Point, and Charlotte Lake."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal destination near Pune known for its sandy beaches, sea forts, and relaxed atmosphere. Travelers booking a sedan cab can visit Alibaug Beach, Kolaba Fort, Nagaon Beach, and Varsoli Beach while enjoying a comfortable road trip. It is ideal for beach lovers, families, and weekend vacations."
  },
    {
    title: "Lonavala",
    description: "Lonavala is one of the most popular hill stations near Pune, known for its lush green valleys, waterfalls, and scenic viewpoints. Travelers booking a sedan cab can enjoy a comfortable drive to explore attractions like Tiger Point, Bhushi Dam, Rajmachi Point, and Karla Caves. The pleasant weather and beautiful landscapes make it an ideal destination for weekend getaways and nature lovers."
  },
  {
    title: "Khandala",
    description: "Khandala is a picturesque hill station located close to Pune, famous for its misty hills, waterfalls, and panoramic viewpoints. Visitors using a sedan cab can enjoy a relaxing journey while exploring Duke’s Nose, Sunset Point, and Rajmachi Fort. The serene surroundings make it perfect for sightseeing, photography, and peaceful retreats."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a renowned hill station near Pune celebrated for its strawberry farms, breathtaking viewpoints, and pleasant climate. Travelers booking a sedan cab can visit Venna Lake, Arthur’s Seat, Elephant’s Head Point, and Mapro Garden while enjoying scenic mountain roads. It is an excellent destination for families, couples, and nature enthusiasts."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a revered pilgrimage destination and wildlife sanctuary nestled in the Sahyadri hills. Travelers using a sedan cab can visit the famous Jyotirlinga temple, explore scenic trekking trails, and experience the rich biodiversity of the surrounding forest. The destination is perfect for spiritual seekers and nature lovers."
  },
  {
    title: "Kaas Plateau",
    description: "Kaas Plateau, also known as the Valley of Flowers of Maharashtra, is a UNESCO World Heritage Site famous for its seasonal bloom of colorful wildflowers. Sedan cab travelers can enjoy a scenic drive from Pune to witness the breathtaking floral landscape, making it an unforgettable destination for nature enthusiasts and photographers."
  },
  {
    title: "Raigad Fort",
    description: "Raigad Fort is one of Maharashtra’s most significant historical landmarks and the former capital of Chhatrapati Shivaji Maharaj. Travelers booking a sedan cab can enjoy a scenic drive to the fort, explore its grand gateways, royal palace ruins, and panoramic hilltop views. The destination offers a perfect blend of history, adventure, and breathtaking scenery."
  }
],



services: [
{
name: "Kia Carens Car Rental Service in Pimpri Chinchwad",
description: "Kia Carens car rental service in Pimpri Chinchwad offers a premium 6–7 seater travel experience for families, corporate groups, and outstation trips. The Kia Carens is known for its spacious interiors, comfortable seating, and smooth performance on highways, making it ideal for long-distance travel. Customers can book rides from Pimpri, Chinchwad, Akurdi, and nearby areas with doorstep pickup and drop. Professional drivers ensure safe driving and timely service for business or leisure travel. Air-conditioned cabins, ample luggage space, and advanced safety features make every journey comfortable. Easy online booking and transparent pricing make it a preferred choice for group travel."
},
{
name: "Kia Carens on Rent in Pune for Outstation",
description: "Kia Carens on rent in Pune for outstation travel provides comfortable and reliable transportation to destinations like Mumbai, Mahabaleshwar, Shirdi, and Lonavala. The vehicle offers premium seating, smooth suspension, and excellent mileage for long journeys. Ideal for families and small groups, it ensures a relaxed travel experience with professional drivers and well-maintained vehicles."
},
{
name: "Kia Carens on Hire for Corporate Events",
description: "Kia Carens on hire for corporate events offers stylish and spacious travel for business meetings, conferences, and employee transportation. With comfortable seating and premium interiors, it is perfect for professional use. Timely service and experienced drivers ensure a smooth corporate travel experience."
},
{
name: "Pune to Mahabaleshwar Kia Carens on Rent",
description: "Pune to Mahabaleshwar Kia Carens rental offers a comfortable hill-station journey with spacious seating and smooth driving. The vehicle is ideal for family trips with luggage and ensures safe travel through ghat roads."
},
{
name: "Pune to Shirdi Kia Carens on Rent",
description: "Pune to Shirdi Kia Carens rental service provides comfortable travel for pilgrimage trips with spacious seating and reliable performance. Ideal for families and groups visiting Shirdi temple."
},
{
name: "Pune to Outstation Kia Carens on Rent",
description: "Pune to outstation Kia Carens rental service offers flexible travel to multiple destinations with comfortable vehicles and professional drivers ensuring safe journeys."
},
{
name: "Cab Service in Pune Kia Carens on Rent",
description: "Cab service in Pune with Kia Carens offers reliable transportation for city rides, airport transfers, and outstation travel with premium comfort."
},
{
name: "Kia Carens on Rent in Pimpri Chinchwad",
description: "Kia Carens on rent in Pimpri Chinchwad provides convenient and comfortable travel for local and outstation trips with flexible booking options."
},
{
name: "7 Seater Kia Carens on Rent in Pune",
description: "7 seater Kia Carens on rent in Pune offers spacious travel for families and groups with ample legroom and luggage space for long journeys."
},
{
name: "Pune Local Kia Carens on Rent",
description: "Pune local Kia Carens rental service provides comfortable city travel for sightseeing, office commute, and daily usage with professional drivers."
},
{
name: "Pune to Outstation Kia Carens Taxi Fare per Km",
description: "Kia Carens taxi fare per km for outstation travel provides transparent pricing based on distance and travel duration, helping customers plan their budget efficiently."
},
{
name: "Kia Carens Car Rental Pune",
description: "Kia Carens car rental Pune offers premium vehicle options for local and outstation travel with reliable service and comfortable seating."
},
{
name: "Kia Carens on Rent in Hinjewadi",
description: "Kia Carens on rent in Hinjewadi provides convenient travel for IT professionals and residents with easy pickup from offices and societies."
},
{
name: "Kia Carens on Rent in Kharadi Pune",
description: "Kia Carens on rent in Kharadi Pune offers reliable transportation for corporate employees and families with comfortable vehicles and timely service."
},
{
name: "Car Hire Agency in Viman Nagar Pune",
description: "Car hire agency in Viman Nagar Pune provides a wide range of vehicle rental options including Kia Carens for local and outstation travel."
},
{
name: "Kia Carens on Rent in Magarpatta City",
description: "Kia Carens on rent in Magarpatta City offers comfortable travel options for residents and professionals with easy booking and reliable service."
},
{
name: "Velocity Cabs Kia Carens Service",
description: "Velocity Cabs provides premium Kia Carens rental services in Pune with reliable vehicles, experienced drivers, and competitive pricing for all travel needs."
},
{
name: "Kia Carens on Rent in Pune",
description: "Kia Carens on rent in Pune offers flexible rental options for city and outstation travel with comfortable seating and modern features."
},
{
name: "Kia Carens Rental Pune",
description: "Kia Carens rental Pune provides dependable travel solutions with well-maintained vehicles and professional drivers ensuring safe journeys."
},
{
name: "Kia Carens Cab in Pune",
description: "Kia Carens cab in Pune offers spacious and comfortable travel for families and groups with reliable service and smooth driving experience."
},
{
name: "Kia Carens Car Hire Pune",
description: "Kia Carens car hire Pune provides premium SUV travel with advanced features and comfortable interiors for long-distance journeys."
},
{
name: "Kia Carens Taxi Service Pune",
description: "Kia Carens taxi service Pune ensures reliable transportation with professional drivers and well-maintained vehicles for all travel needs."
},
{
name: "Book Kia Carens Cab Pune",
description: "Book Kia Carens cab Pune easily through online platforms with instant confirmation and transparent pricing for hassle-free travel."
}
],

tableData: [
["Kia Carens Car Rental Service in Pimpri Chinchwad","Kia Carens on Rent in Pune for Outstation"],
["Kia Carens on Hire for Corporate Events","Pune to Mahabaleshwar Kia Carens on Rent"],
["Pune to Shirdi Kia Carens on Rent","Pune to Outstation Kia Carens on Rent"],
["Cab Service in Pune Kia Carens on Rent","Kia Carens on Rent in Pimpri Chinchwad"],
["7 Seater Kia Carens on Rent in Pune","Pune Local Kia Carens on Rent"],
["Pune to Outstation Kia Carens Taxi Fare per Km","Kia Carens Car Rental Pune"],
["Kia Carens on Rent in Hinjewadi","Kia Carens on Rent in Kharadi Pune"],
["Car Hire Agency in Viman Nagar Pune","Kia Carens on Rent in Magarpatta City"],
["Velocity Cabs Kia Carens Service","Kia Carens on Rent in Pune"],
["Kia Carens Rental Pune","Kia Carens Cab in Pune"],
["Kia Carens Car Hire Pune","Kia Carens Taxi Service Pune"],
["Book Kia Carens Cab Pune","Kia Carens Car Rental Pune"]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Kia Carens for Pune Travel",
    WhyChoosedescription: "Velocity Cabs offers Kia Carens on rent in Pune with premium comfort, spacious seating, and modern interiors, making it perfect for family trips, airport transfers, and outstation travel."
  },
  {
    WhyChooseheading: "Experienced Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Pune city routes and highways, ensuring safe driving, smooth journeys, and timely pickups and drop-offs."
  },
  {
    WhyChooseheading: "Transparent Rental Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent and affordable pricing for Kia Carens rental in Pune. Customers receive complete fare details including per km charges, toll charges, and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Rental Availability",
    WhyChoosedescription: "Our Kia Carens rental service in Pune operates 24/7. Whether you need airport transfer, business travel, or late-night rides, we ensure reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Sanitized AC Vehicles",
    WhyChoosedescription: "All Kia Carens vehicles are fully air-conditioned, well maintained, and regularly sanitized to provide a safe and comfortable travel experience."
  },
  {
    WhyChooseheading: "Flexible Rental Options",
    WhyChoosedescription: "Velocity Cabs offers flexible rental options including local travel (8 hours/80 km), outstation trips, one-way travel, round-trip bookings, and customized packages based on your requirements."
  },
  {
    WhyChooseheading: "Ideal for Family & Group Travel",
    WhyChoosedescription: "Kia Carens is ideal for families and small groups with seating capacity for 6 to 7 passengers and sufficient luggage space for long-distance travel."
  },
  {
    WhyChooseheading: "Trusted Car Rental Service in Pune",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for Kia Carens on rent in Pune due to professional drivers, clean vehicles, and reliable service quality."
  }
]
};

const faqData = [
  { question: "Do you provide Kia Carens on rent in Pune?", answer: "Yes, Velocity Cabs provides Kia Carens rental services in Pune for local and outstation travel." },
  { question: "What is the price of Kia Carens on rent in Pune?", answer: "The rental cost typically starts from ₹14 to ₹18 per km or ₹2200 to ₹3800 per day depending on the package and duration." },
  { question: "How many passengers can travel in Kia Carens?", answer: "Kia Carens can comfortably accommodate 6 to 7 passengers along with luggage." },
  { question: "Is Kia Carens available for airport transfers?", answer: "Yes, we provide airport pickup and drop services in Pune using Kia Carens vehicles." },
  { question: "Can I book Kia Carens for outstation trips?", answer: "Yes, Kia Carens is available for outstation travel from Pune to destinations like Mumbai, Shirdi, Goa, and Mahabaleshwar." },
  { question: "Is rental service available 24 hours?", answer: "Yes, our Kia Carens rental service in Pune operates 24/7." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all Kia Carens vehicles are fully air-conditioned and well maintained." },
  { question: "Can I book Kia Carens online?", answer: "Yes, customers can easily book Kia Carens on rent in Pune online or through phone booking." },
  { question: "Is driver included in the rental?", answer: "Yes, all rentals include professional drivers for a safe and comfortable journey." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback:
      "The Kia Carens on rent in Pune turned out to be a great choice for our family trip. The cabin was spacious, clean, and very comfortable for long travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Patil",
    feedback:
      "Smooth and comfortable experience with the Kia Carens rental in Pune. The vehicle felt premium, seating was excellent, and the journey was stress-free.",
    rating: 5
  }
];





























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const puneKiaCarensJSON = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Kia Carens On Rent in Pune | Velocity Cabs",
  "description": "Rent a Kia Carens in Pune with Velocity Cabs for outstation trips, corporate events, airport transfers, and local city travel. 7-seater Kia Carens available for safe and comfortable journeys.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune, Maharashtra, India"
  },
  "serviceType": [
    "Kia Carens Car Rental Pune",
    "Pune to Mahabaleshwar Kia Carens Rental",
    "Pune to Shirdi Kia Carens Cab",
    "Outstation Kia Carens Hire Pune",
    "Corporate Event Kia Carens Rental Pune",
    "Local Kia Carens On Rent Pune",
    "Pimpri-Chinchwad Kia Carens Rental",
    "Hinjewadi Kia Carens Rental",
    "Kharadi Kia Carens Rental"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Kia Carens On Rent in Pune | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Rent a 7-seater Kia Carens in Pune with Velocity Cabs. Perfect for outstation trips, corporate events, airport transfers, and local city travel. Book now for safe and comfortable rides."
  />
  <script type="application/ld+json">
    {JSON.stringify(puneKiaCarensJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/71.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kiacarenceonrentinpune;